import { Module } from '@/modules/core/app/constants/app.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { HintReportsRouteConfig } from '@/modules/ta/hintreports/HintReportsRouteConfig';
import {
  HintReportsPathName,
  HintReportsRoute,
} from '@/modules/ta/hintreports/hintreports.constants';

export const router = HintReportsRouteConfig.factory(
  [
    {
      path: `/${HintReportsRoute.HINT_REPORTS}`,
      redirect: () => `/${HintReportsRoute.HINT_REPORTS_SLIDES}`,
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS}/:tab?`,
      name: HintReportsPathName.HINT_REPORTS,
      component: () =>
        import(/* webpackChunkName: "hintreports-page" */ './pages/HintReportsPage.vue'),
      props: true,
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS_SLIDE}/new`,
      alias: RouteGroup.CREATE_SMARTSLIDE,
      name: HintReportsPathName.HINT_REPORTS_FORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "hintreportsform-new-page" */ './pages/HintReportsFormPage.vue'
        ),
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS_SLIDE}/:id`,
      name: HintReportsPathName.HINT_REPORTS_FORM,
      component: () =>
        import(/* webpackChunkName: "hintreportsform-page" */ './pages/HintReportsFormPage.vue'),
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS_TEMPLATE}/new`,
      name: HintReportsPathName.HINT_REPORTS_TEMPLATE_FORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "hintreportstemplateform-page" */ './pages/HintReportsTemplateFormPage.vue'
        ),
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS_TEMPLATE}/:id`,
      name: HintReportsPathName.HINT_REPORTS_TEMPLATE_FORM,
      component: () =>
        import(
          /* webpackChunkName: "hintreportstemplateform-page" */ './pages/HintReportsTemplateFormPage.vue'
        ),
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS}/generate/:id`,
      name: HintReportsPathName.HINT_REPORTS_GENERATE,
      component: () =>
        import(
          /* webpackChunkName: "hintreportsgenerate-page" */ './pages/HintReportsGeneratePage.vue'
        ),
    },
    {
      path: `/${HintReportsRoute.HINT_REPORTS}/preview/:id`,
      name: HintReportsPathName.HINT_REPORTS_PREVIEW,
      component: () =>
        import(
          /* webpackChunkName: "hintreportspreview-page" */ './pages/HintReportsPreviewPage.vue'
        ),
    },
  ],
  Module.HINTREPORTS
);
